import { render, staticRenderFns } from "./CommissionManagementChart.vue?vue&type=template&id=083aed25"
import script from "./CommissionManagementChart.vue?vue&type=script&lang=js"
export * from "./CommissionManagementChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports